import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Item from '../../assets/DigitalCoursesAsset/CourseItem.jpg'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {md: 'auto', xs: 350},
  bgcolor: 'background.paper',
  border: '1px solid #fff',
  borderRadius: '25px',
 display:'flex',
 justifyContent:'center',
 alignItems: 'center',
 flexDirection:'column',
 overflowY: {xs: 'auto', md: 'hidden'},
  p: 2,
};

export default function AppModal({setShowModal, showModal, icon,title='',message,children}) {
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);

  
  // const handleClose = () => setShowModal(false);

  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={showModal}
        // onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={showModal}>
          <Box sx={style}>
            <Box sx={{width: {md: 30, xs: 50}, height: {md: 30, xs: 50}, borderRadius:'50%', my: 3}}>
            <img src={icon} style={{color:'#1D9E34', width:'60px', height:'60px',}} alt='check out icon' />
              
            {/* <CheckCircleIcon sx={{color:'#1D9E34', fontSize: {md:60, xs: 40}}}/> */}
            </Box>
          
            <Box>
            <Typography id="transition-modal-title" variant="h6" component="h2" sx={{textAlign:'center', color: theme=>theme.palette.secondary.main, mt: 1, fontWeight: 500, fontSize:{md: 30, xs: 16}}}>
              {title}
            {/* Purchase Successful. */}
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 1, textAlign:'center',lineHeight: 1.5, fontSize: {md: 20, xs: 14}, marginTop: 2}}>
            {message?.beforeSpan}
      <span style={{ color: '#5604F6', marginLeft: '10px' }}> {message?.spanContent}</span>
      {message?.afterSpan}
            {/* Congratulations! You’ve successfully purchased <span style={{ color: '#5604F6',}}>'Mastering Social Media Marketing.'</span>  All course materials have been sent to your email and WhatsApp. Let’s start learning. */}
            </Typography>
            </Box>
            {children}
           {/* <Box sx={{border: '1px solid #D2D1D6', borderRadius: '8px', padding: {md: 2, xs: 1}, display:'flex', flexDirection:'column', width:'100%', marginTop: 4}}>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>
                 Course Purchased
              </Typography>
              <Box sx={{display:'flex', alignItems:'center', gap: {xs: 1, md: 2}, paddingBottom: 1}}>
                <Box sx={{width: '35px', height: '30px', borderRadius:'15px'}}>
                <img src={Item} alt="item purchased" style={{width: '35px', height:'30px', borderRadius:'5px'}} />
                </Box>
               
                <Typography sx={{textTransform:'capitalize', fontSize: 12}}>Mastering Social Media Marketing</Typography>
              </Box>
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              quantity
              </Typography>
              <Typography sx={{fontSize: 12}}>1 Unit</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1,fontSize: 12}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              price
              </Typography>
              <Typography sx={{fontSize: 12}}>₦10,000</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              order I.D
              </Typography>
              <Typography sx={{fontSize: 12}}>₦10,000</Typography>
             
             </Box>
           </Box>
           <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%'}}>



{/* Add to Favorites Button 
<Box sx={{ marginTop: 1,width: 'auto' }}>
  <Button
    variant="contained"
    color="secondary"
    sx={{
      width: '100%',
      
      padding: {md: '10px 20px', xs: '5px 8px'},
      border: '1px solid #CBB1FC',
      borderRadius: '25px',
     
      textTransform:'capitalize',
      backgroundColor:'#fff',
      color:'#5604F6',
   
    }}
  >
    view recent orders
  </Button>
</Box>

{/* Order Now Button 
<Box sx={{ marginTop: 2, width: 'auto'}}>
  <Button
    variant="contained"
    color="success"
  
    sx={{
      width: '100%',
      padding: {md: '10px 20px', xs: '5px 8px'},
      borderRadius: '25px',
        textTransform:'capitalize',
        backgroundColor: '#5604F6',
        color:'#fff'
    }}
  >
    check your email 
  </Button>
</Box>
</Box>
<Box sx={{alignSelf:'flex-start', marginTop: 2}}>
  <Typography>Need help?</Typography>
  <Typography>
  Contact our support team via <span style={{color: '#F6A704', cursor:'pointer'}}>WhatsApp or email</span>   for assistance.</Typography>
</Box> */}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
